const hasValue = (obj) => {
  return !(obj === null || typeof obj === 'undefined' || obj === '')
}


class LocalStorageHelper {


  getIKey() {
    return localStorage.getItem('userId') || localStorage.getItem('lastUser')
  }

  getPageNameSpace() {
    return location.hostname + location.pathname.split('/').join('.')
  }

  getItem(key) {
    const local = localStorage.getItem(this.getIKey())
    const namespace = this.getPageNameSpace()
    if (!hasValue(local)) {
      return null
    }
    if (!hasValue(JSON.parse(local)[namespace])) {
      return null
    }
    return (JSON.parse(local))[this.getPageNameSpace().toString()][key]
  }

  setItem(key, val) {
    const local = localStorage.getItem(this.getIKey())
    const namespace = this.getPageNameSpace()
    if (!hasValue(local)) {
      const o = {}
      o[namespace] = {}
      o[namespace][key] = val
      localStorage.setItem(this.getIKey(), JSON.stringify(o))
    } else {
      const ls = JSON.parse(local)
      if (!hasValue(ls[namespace])) {
        ls[namespace] = {}
      }
      ls[namespace][key] = val
      localStorage.setItem(this.getIKey(), JSON.stringify(ls))
    }
  }

}

export default new LocalStorageHelper()

